import React from 'react'
import PropTypes from 'prop-types'
import parseGGDriver from '../helpers/parseGGDriver'

class ImportItemsItem extends React.Component {

    render() {
        const {index, item} = this.props
        const {isShow, generate_label_config} = item

        const mockUpFront = parseGGDriver(item.mockUpFront)
        const mockUpBack = parseGGDriver(item.mockUpBack)
        const designFront = parseGGDriver(item.designFront)
        const designBack = parseGGDriver(item.designBack)

        return (isShow ?
            <tr className='ImportItemsItem'>
                <td>{index + 1}</td>
                <td>{item.orderNumber}</td>
                <td className='Marketplace'>{item.Marketplace}</td>
                <td>
                    {mockUpFront && <img className='zoom' src={mockUpFront} alt='Link' />}
                </td>
                <td>
                    {mockUpBack && <img className='zoom' src={mockUpBack} alt='Link' />}
                </td>
                <td>
                    <img className='design' src={designFront} alt='' style={{ background: item.color }} />
                </td>
                <td>
                    <img className='design' src={designBack} alt='' style={{ background: item.color }} />
                </td>
                <td>{item.type}</td>
                <td>{item.size}</td>
                <td>{item.color}</td>
                <td>{item.quantity}</td>
                <td>
                    <span className='d-block'>{item.name}</span>
                    <span className='d-block'>{item.address1}</span>
                    <span className='d-block'>{item.address2}</span>
                    <span className='d-block'>{item.city + ' ' + item.state + ' ' + item.postalCode}</span>
                    <span className='d-block'>{item.country}</span>
                </td>
                <td>
                    <span className='d-block'>{item.return_name}</span>
                    <span className='d-block'>{item.return_address1}</span>
                    <span className='d-block'>{item.return_address2}</span>
                    <span className='d-block'>{item.return_city + ' ' + item.return_state + ' ' + item.return_postalCode}</span>
                    <span className='d-block'>{item.return_countryCode}</span>
                </td>
                <td>{JSON.stringify(generate_label_config || {})}</td>
            </tr> :
            <tr className='ImportItemsItem BorderNone'>
                <td>{index + 1}</td>
                <td>{item.orderNumber}</td>
                <td>
                    <img className='zoom' src={mockUpFront} alt='' />
                </td>
                <td>
                    <img className='zoom' src={mockUpBack} alt='' />
                </td>
                <td>
                    <img className='design' src={designFront} alt='' style={{ background: item.color }} />
                </td>
                <td>
                    <img className='design' src={designBack} alt='' style={{ background: item.color }} />
                </td>
                <td>{item.type}</td>
                <td>{item.size}</td>
                <td>{item.color}</td>
                <td>{item.quantity}</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>{JSON.stringify(generate_label_config || {})}</td>
            </tr>
        )
    }
}

ImportItemsItem.propTypes = {
    index: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired
}

export default ImportItemsItem
